import React, { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface ThreadSidebarContextType {
  isSidebarVisible: boolean;
  toggleSidebar: () => void;
  showSidebar: () => void;
  hideSidebar: () => void;
}

const ThreadSidebarContext = createContext<ThreadSidebarContextType | undefined>(undefined);

export const ThreadSidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  const toggleSidebar = useCallback(() => {
    setIsSidebarVisible(prev => !prev);
  }, []);

  const showSidebar = useCallback(() => {
    setIsSidebarVisible(true);
  }, []);

  const hideSidebar = useCallback(() => {
    setIsSidebarVisible(false);
  }, []);

  return (
    <ThreadSidebarContext.Provider value={{ 
      isSidebarVisible, 
      toggleSidebar,
      showSidebar,
      hideSidebar
    }}>
      {children}
    </ThreadSidebarContext.Provider>
  );
};

export const useThreadSidebar = () => {
  const context = useContext(ThreadSidebarContext);
  if (!context) {
    throw new Error('useThreadSidebar must be used within a ThreadSidebarProvider');
  }
  return context;
};